import { Component } from '@angular/core';
import { PatientsIntroComponent } from './patients-intro/patients-intro.component';
import { PatientsPlanInfoComponent } from "./patients-plan-info/patients-plan-info.component";
import { PatientsPlanPricingComponent } from './patients-plan-pricing/patients-plan-pricing.component';
import { PatientsApplicationFormComponent } from './patients-application-form/patients-application-form.component';
import { PatientsFaqComponent } from "./patients-faq/patients-faq.component";
import { PatientsComingSoonComponent } from './patients-coming-soon/patients-coming-soon.component';

@Component({
  selector: 'app-patients',
  standalone: true,
  imports: [
    PatientsIntroComponent,
    PatientsPlanInfoComponent,
    PatientsPlanPricingComponent,
    PatientsApplicationFormComponent,
    PatientsFaqComponent,
    PatientsComingSoonComponent
],
  templateUrl: './patients.component.html',
  styleUrl: './patients.component.scss'
})
export class PatientsComponent {
}